import {ClickEvent} from "../../../infrastructure/models/analytics/click-event";
import {GoogleAnalyticsEventModel} from "../../../third-party-services/analytics/google-analytics/google-analytics-event-model";

export class NotificationsPermissionClickEvent extends ClickEvent {
  type: String;
  trigger: String;
  clickType: String;
  numShown: Number;

  constructor(params) {
    super('click', 'permission', 'notifications');

    this.type = params.type;
    this.trigger = params.trigger;
    this.clickType = params.clickType;
    this.numShown = params.numShown;
  }

  get properties() {
    const properties = super.properties;

    properties.type = this.type;
    properties.trigger = this.trigger;
    properties.clickType = this.clickType;
    properties.numShown = this.numShown;

    return properties;
  }

  get googleAnalyticsEvent(): null {
    const eventName = this.resolveEventName();
    return new GoogleAnalyticsEventModel(eventName, {
      type: this.type,
      trigger: this.trigger,
      clickType: this.clickType
    })
  }
}
